<template>
  <nav class="breadcrumb-v2">
    <ul>
      <li v-for="(item, index) in breadcrumbs" :key="index">
        <span class="main">{{ item.text }}</span>
        <span v-if="index < breadcrumbs.length - 1"> > </span>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "BreadcrumbV2",
  props: {
    breadcrumbs: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
.breadcrumb-v2 {
  display: flex;
  padding-bottom: 0px;
  font-weight: 500;
  color: #444;
  font-family: TTNormsMedium, sans-serif;
}

.breadcrumb-v2 ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 0px;
}

.breadcrumb-v2 li {
  display: flex;
  align-items: center;
  gap: 8px;
}

.breadcrumb-v2 .main {
  color: #005eb8;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb-v2 span {
  color: #666;
}
</style>
